import React, { useEffect } from "react";
import { observer } from "mobx-react-lite";
import Retool from ".";
import MainLayout from "layouts/MainLayout";
import { useParams } from "react-router";
import { buildingStore } from "store/Building/BuildingStore";
import { useTranslation } from "react-i18next";

const ManufacturerDashboard = () => {
  const reportID = "36e34806-03e8-11f0-8438-67a228567e95";
  const { organisation_id } = useParams();
  const { t } = useTranslation();

  const embeddedData = {
    organisation_id: organisation_id,
  };

  useEffect(() => {
    // deselect building from the menu
    buildingStore.setCurrentBuilding(undefined);
  }, [organisation_id]);

  return (
    <MainLayout
      headerTitle={t("dashboard.manufacturerDashboard")}
      className="!max-h-[calc(100vh-64px)] overflow-hidden"
    >
      <Retool url={reportID} embeddedData={embeddedData} />
    </MainLayout>
  );
};

export default observer(ManufacturerDashboard);
